// @ts-nocheck
import { createHandlerChainRunnerOptionalParameter, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler;

export const DispatchApplyDraftParameter: HandlerType = props => {
    props.dispatch({
        type: "Greif/Pages/TrailerTrackingV2/ApplyDraftParameter",
    });
};

export const chain = [DispatchApplyDraftParameter];

const applyDraftParameter = createHandlerChainRunnerOptionalParameter(chain, {}, "ApplyDraftParameter");
export default applyDraftParameter;
